import BookIcon from '@material-ui/icons/Book'
import WishListShow from './WishListShow'
import WishListList from './WishListList'

export default {
  list: WishListList,
  show: WishListShow,
  icon: BookIcon,
}
